import { render } from "./ExternalMocForm.vue?vue&type=template&id=ff0994d4"
import script from "./ExternalMocForm.vue?vue&type=script&lang=js"
export * from "./ExternalMocForm.vue?vue&type=script&lang=js"

import "./ExternalMocForm.vue?vue&type=style&index=0&id=ff0994d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__